import React from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { useField } from 'formik';

import { FormField, Select, Option } from '@xingternal/text-field';

import styles from './PagesFormField.css';

type OptionItemType = {
  value?: string | null;
  text?: string | null;
};

type PagesFormFieldProps = {
  name: string;
  optionList?: Array<OptionItemType>;
  defaultValue?: number;
  required?: boolean;
  shouldTrim?: boolean;
  copyPrefix?: string;
  maxAllowedChars?: number;
  className?: string;
  type?: string;
};

const PagesFormField = ({
  name,
  optionList,
  defaultValue,
  required,
  shouldTrim,
  copyPrefix = 'EP_EDIT_',
  maxAllowedChars,
  className,
  ...props
}: PagesFormFieldProps) => {
  const intl = useIntl();
  const [field, meta] = useField(name);

  if (optionList) {
    return (
      <Select
        {...field}
        value={field?.value || defaultValue || ''}
        error={!!meta?.error}
        placeholder={intl.formatMessage({
          id: copyPrefix + name.toUpperCase(),
        })}
        medium
        className={cx(styles.field, className)}
        {...props}
      >
        {optionList.map((item, index) => (
          item.value ? (<Option key={'pageFieldOption'+ name + index} value={item.value}>
            {item.text}
          </Option>) : null
        ))}
      </Select>
    );
  }

  return (
    <FormField
      {...field}
      helperText={
        meta?.error
          ? meta?.error
          : maxAllowedChars
          ? intl.formatMessage(
              {
                id: 'EP_INPUT_CHARS_LEFT',
              },
              {
                charactersNumber: maxAllowedChars - field?.value?.length,
              }
            )
          : !required
          ? intl.formatMessage({
              id: 'EP_OPTIONAL_FIELD_HINT',
            })
          : undefined
      }
      error={!!meta?.error}
      label={intl.formatMessage({
        id: copyPrefix + name.toUpperCase(),
      })}
      medium
      className={cx(styles.field, className)}
      data-testid={'PAGES_FIELD_' + name}
      {...props}
    />
  );
};

export default PagesFormField;
